export default __webpack_public_path__ + "static/media/loader-icon.d22177a7.svg";